function getValuesReady(selectedValues){
    if(selectedValues instanceof Array){
        selectedValues = selectedValues.map(function(v) {
            return v === null ? null : v.toString()
        });
    }else if(selectedValues){
        selectedValues = [selectedValues]
    }else{
        selectedValues = [];
    }
    return selectedValues;
}

function reloadApplicantAddressCities(countryInput){
    let name = countryInput.name.replace('[country]', '[city]');
    let $cityInput = $('[name="'+name+'"]')
    let currentValues = $cityInput.val();
    let isDisabled = $cityInput.prop('disabled')

    $cityInput.prop("disabled", true);

    $.ajax({
        url: '/countries_cities/cities',
        data: {
            country: countryInput.value
        }
    }).done(function (data) {
        if(!currentValues.length && $cityInput.data('value')) {
            currentValues = getValuesReady($cityInput.data('value'));
        }
        $cityInput.html('<option style="display: none"></option>');
        $.each(data, function(index, value){
            var selected = currentValues.toString().split(',').indexOf(value.id.toString()) > -1;
            var option = new Option(value.title, value.id, false, selected);
            $cityInput.append(option);
        });

        if (currentValues && !Number.isInteger(parseInt(currentValues))) {
            var option = new Option(currentValues, currentValues, false, true);
            $cityInput.append(option);
        }

        $cityInput.prop("disabled", isDisabled).change();
    })
}

$('form').on('change', '[data-applicantaddress="country"]', function (e){
    reloadApplicantAddressCities(this)
})

$('[data-applicantaddress="country"]').each(function (){
    reloadApplicantAddressCities(this)
})